export default "__VITE_ASSET__DWjDrbHB__"